module.exports = __webpack_public_path__ + "img/garantie-alternative.c64e0e30.svg";